import { Filter } from "types/types"

const performFilterSearch = <T extends Filter>(filterList: T[], searchValue: string): T[] => {
  const trimmedSearchValue = searchValue.trim()
  const shouldSearch = trimmedSearchValue.length > 0
  if (!shouldSearch) return filterList

  return filterList.filter((filter) =>
    filter.label.toLocaleLowerCase().includes(trimmedSearchValue.toLocaleLowerCase()),
  )
}

export default performFilterSearch
